// extracted by mini-css-extract-plugin
module.exports = {"infoWidget":"CallbackConnected_infoWidget_Z2VtG"};